"use client";

import type { Pages, Section as SectionType } from "@packages/sdk";
import { useRequestSection } from "@packages/sdk";
import { Section, Sections } from "@packages/ui/emotion";

type SectionClientProps = {
  initialData: Pages | SectionType;
  id: string;
};

export const SectionClient = ({ id, initialData }: SectionClientProps) => {
  const { query: querySections } = useRequestSection({
    id,
    initialData,
  });

  return (
    <Sections title={querySections.data?.title}>
      <Section section={querySections.data} screenName="section_details" />
    </Sections>
  );
};
